import React from 'react';

interface StoreBadgesProps {
  badges: any[];
  isUltraLargeTablet: boolean;
  isMobile: boolean;
  selectedLocale: string;
}

const StoreBadges: React.FC<StoreBadgesProps> = ({ badges, isUltraLargeTablet, isMobile, selectedLocale }) => (
  <div className="flex w-fit flex-col gap-y-8">
    {badges?.slice(0, 3)?.map((item: any, index: number) => {
      const styles = item?.styles;
      const isGradient = styles?.backgroundGradient?.startsWith('linear-gradient');
      const iconPosition = item?.icon?.position || 'left';
      const iconType = item?.icon?.positioning?.type || 'relative';
      const iconAsset = item?.icon?.asset?.[selectedLocale];
      const iconSize = isUltraLargeTablet
        ? Math.min(item?.icon?.iconSizeDesktopPx ?? 0, 22)
        : Math.min(item?.icon?.iconSizeMobilePx ?? 0, 18);
      const iconPositioning = item?.icon?.positioning?.[isMobile ? 'mobile' : 'desktop'] || {
        top: 0,
        left: 0,
      };

      const inlineStyles = {
        ...(isGradient
          ? { backgroundImage: styles?.backgroundGradient }
          : { backgroundColor: styles?.backgroundColor }),
        padding: isMobile ? styles?.paddingMobile : styles?.paddingDesktop,
        minHeight: `${isMobile ? styles?.minHeightMobilePx : styles?.minHeightDesktopPx}px`,
        maxHeight: `${isMobile ? styles?.maxHeightMobilePx : styles?.maxHeightDesktopPx}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: `${isMobile ? styles?.columnGapMobilePx : styles?.columnGapDesktopPx}px`,
        borderWidth: `${styles?.borderThickness || 0}px`,
        borderColor: styles?.borderColor,
        borderRadius: styles?.borderRadius ? `${styles?.borderRadius}px` : undefined,
      };
      const shouldUseLineBreak = isUltraLargeTablet ? styles?.manualLineBreakDesktop : styles?.manualLineBreakMobile;
      const iconStyle: React.CSSProperties = {
        position: iconType,
        top: iconPositioning?.top ?? 0,
        left: iconPositioning?.left ?? 0,
        width: iconSize,
        height: iconSize,
        ...(iconPosition === 'left' && { marginRight: item?.icon?.spacingPx ?? 0 }),
        ...(iconPosition === 'right' && { marginLeft: item?.icon?.spacingPx ?? 0 }),
      };
      const iconElement = iconAsset && (
        <img
          src={`https://${iconAsset?.endpoint}.a.bigcontent.io/v1/static/${iconAsset?.name}`}
          alt=""
          width={iconSize}
          height={iconSize}
          style={iconStyle}
        />
      );

      const label = item?.label?.[selectedLocale] || '';

      return (
        <div key={index} style={inlineStyles} className="w-fit">
          {iconPosition === 'left' && iconElement}
          {shouldUseLineBreak ? (
            <p
              style={{
                color: styles?.textColor,
                fontSize: `${isMobile ? styles?.fontSizeMobilePx : styles?.fontSizeDesktopPx}px`,
                fontWeight: styles?.fontWeight,
                letterSpacing: styles?.letterSpacing ? `${styles?.letterSpacing}px` : undefined,
              }}
              className="text-center"
              dangerouslySetInnerHTML={{ __html: label }}
            />
          ) : (
            <p
              style={{
                color: styles?.textColor,
                fontSize: `${isMobile ? styles?.fontSizeMobilePx : styles?.fontSizeDesktopPx}px`,
                fontWeight: styles?.fontWeight,
                letterSpacing: styles?.letterSpacing ? `${styles?.letterSpacing}px` : undefined,
              }}
              className="text-center"
            >
              {label?.replace(/<[^>]*>/g, '')}
            </p>
          )}
          {iconPosition === 'right' && iconElement}
        </div>
      );
    })}
  </div>
);

export default StoreBadges;
